<template>
  <div class="black_panel_cla">
    <zk-table
      :data="tableData"
      :columns="columnData"
      style="min-height:300px;height: auto;"
    ></zk-table>
    <div class="pagination-margin-top">
      <el-pagination
        background
        @size-change="changePageSize"
        @current-change="changePage"
        :current-page="pager.curPage"
        :page-size="pager.pageSize"
        layout="total, prev, pager, next, sizes, jumper"
        :total="pager.total"
      ></el-pagination>
    </div>
    <el-drawer :with-header="false" :visible.sync="drawer" direction="rtl">
      <div class="timeSlotDetails-title-cla">
        {{ $t('accManager.timeSlotDetails') }}
      </div>
      <div style="padding:40px">
        <el-table :data="currentDetails.timezoneList" style="width: 100%">
          <el-table-column prop="week" label="week">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{
                getWeekDay(scope.row.week)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="time" width="180">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.startName }}</span>
              <span style="margin-left: 10px">---</span>
              <span style="margin-left: 10px">{{ scope.row.endTime }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {
  findAccTimezoneByPage,
  findAccTimezoneDetailByTimezoneNum
} from '@/services/accManager.js'
export default {
  data() {
    return {
      tableData: [],
      params: {},
      drawer: false,
      currentDetails: {},
      columnData: [
        {
          label: this.$t('accManager.timezoneName'),
          prop: 'timezoneName'
        },
        {
          label: this.$t('common.action'),
          prop: 'timezoneNum',
          render: (h, params) => {
            return h(
              'span',
              {
                class: {
                  'action-btn-cla': true
                },
                on: {
                  click: () => {
                    this.details(params.row)
                  }
                }
              },
              [this.$t('common.details')]
            )
          }
        }
      ]
    }
  },
  mounted() {
    this.commQuery()
  },
  methods: {
    getWeekDay(myddy) {
      var weekday = [
        this.$t('common.sunday'),
        this.$t('common.monday'),
        this.$t('common.tuesday'),
        this.$t('common.wednesday'),
        this.$t('common.thursday'),
        this.$t('common.friday'),
        this.$t('common.saturday'),
        this.$t('accManager.holiday1'),
        this.$t('accManager.holiday2'),
        this.$t('accManager.holiday3')
      ]
      return weekday[myddy]
    },
    details(row) {
      this.drawer = false
      findAccTimezoneDetailByTimezoneNum({
        timezoneNum: row.timezoneNum
      })
        .then(data => {
          if (data.code === '00000000') {
            this.drawer = true
            this.currentDetails = data.payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage()
        })
    },
    changePage(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    commQuery() {
      findAccTimezoneByPage({
        params: this.params,
        pager: this.pager
      })
        .then(data => {
          if (data.code === '00000000') {
            let payload = data.payload
            this.pager.total = payload.totalRecords
            this.pager.curPage = payload.curPage
            this.pager.pageSize = payload.pageSize
            this.tableData = payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage()
        })
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/styles/var.less';
/deep/.action-btn-cla {
  cursor: pointer;
}
.timeSlotDetails-title-cla {
  margin-top: 10px;
  margin-left: 5px;
  padding-left: 10px;
  height: 22px;
  line-height: 22px;
  border-left: 5px solid @statusSuccess;
}
</style>



// WEBPACK FOOTER //
// src/modules/accManager/accManager/timeSlot.vue